import React, { Component } from 'react'

class MemoDialog extends Component {
	constructor(props) {
		super(props)
		this.state = {
			text: props.initialText || ''
		}
		this.handleSave = this.handleSave.bind(this)
		this.handleKeyDown = this.handleKeyDown.bind(this)
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.visible && this.props.visible) {
			this.setState({ text: this.props.initialText || '' })
		}
	}

	handleSave() {
		const trimmed = this.state.text.trim()
		if (trimmed) {
			this.props.onSave(trimmed)
		}
	}

	handleKeyDown(e) {
		if (e.key === 'Enter' && e.ctrlKey) {
			this.handleSave()
		}
		if (e.key === 'Escape') {
			this.props.onCancel()
		}
		e.stopPropagation()
	}

	render() {
		if (!this.props.visible) return null

		const overlayStyle = {
			position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
			backgroundColor: 'rgba(0,0,0,0.35)',
			zIndex: 2000,
			display: 'flex', alignItems: 'center', justifyContent: 'center'
		}

		const dialogStyle = {
			backgroundColor: '#fff',
			borderRadius: 8,
			padding: 20,
			minWidth: 290,
			maxWidth: 380,
			boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
			border: '2px solid #4caf50'
		}

		const titleStyle = {
			marginBottom: 12,
			color: '#2e7d32',
			fontWeight: 'bold',
			fontSize: 15
		}

		const btn = (bg) => ({
			padding: '6px 14px',
			marginRight: 8,
			border: 'none',
			borderRadius: 4,
			cursor: 'pointer',
			backgroundColor: bg,
			color: '#fff',
			fontSize: 13,
			fontWeight: 'bold'
		})

		return (
			<div style={overlayStyle} onClick={this.props.onCancel}>
				<div style={dialogStyle} onClick={e => e.stopPropagation()}>
					<div style={titleStyle}>備忘貼紙</div>
					<textarea
						autoFocus
						rows={4}
						style={{
							width: '100%', resize: 'vertical', fontSize: 13,
							border: '1.5px solid #4caf50', borderRadius: 4,
							padding: '6px 8px', boxSizing: 'border-box',
							fontFamily: 'sans-serif', outline: 'none'
						}}
						value={this.state.text}
						onChange={e => this.setState({ text: e.target.value })}
						onKeyDown={this.handleKeyDown}
						placeholder="輸入備忘內容..."
					/>
					<div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
						<button style={btn('#4caf50')} onClick={this.handleSave}>儲存</button>
						{this.props.mode === 'edit' && (
							<button style={btn('#e53935')} onClick={this.props.onDelete}>刪除</button>
						)}
						<button style={btn('#757575')} onClick={this.props.onCancel}>取消</button>
						<span style={{ marginLeft: 'auto', fontSize: 11, color: '#aaa' }}>Ctrl+Enter 儲存</span>
					</div>
				</div>
			</div>
		)
	}
}

export default MemoDialog
